import React from "react";
import { useEditorStore } from "../../../../../state/editorStore";
import styles from "./Align.module.css";

const Align = () => {

  const layout = useEditorStore((state) => state.layout);
  const updateLayout = useEditorStore((state) => state.updateLayout);

  const setAlign = (x, y) => {
  updateLayout("alignX", x);
  updateLayout("alignY", y);
};

  const isActive = (x, y) =>
    layout.alignX === x && layout.alignY === y;

  return (
    <div className={styles.alignCard}>
      <div className={styles.title}>Align</div>

      <div className={styles.grid}>

        <button
          className={`${styles.button} ${isActive("left","top") ? styles.active : ""}`}
          onClick={() => setAlign("left","top")}
        >↖</button>

        <button
          className={`${styles.button} ${isActive("center","top") ? styles.active : ""}`}
          onClick={() => setAlign("center","top")}
        >↑</button>

        <button
          className={`${styles.button} ${isActive("right","top") ? styles.active : ""}`}
          onClick={() => setAlign("right","top")}
        >↗</button>

        <button
          className={`${styles.button} ${isActive("left","center") ? styles.active : ""}`}
          onClick={() => setAlign("left","center")}
        >←</button>

        <button
          className={`${styles.button} ${isActive("center","center") ? styles.active : ""}`}
          onClick={() => setAlign("center","center")}
        >•</button>

        <button
          className={`${styles.button} ${isActive("right","center") ? styles.active : ""}`}
          onClick={() => setAlign("right","center")}
        >→</button>

        <button
          className={`${styles.button} ${isActive("left","bottom") ? styles.active : ""}`}
          onClick={() => setAlign("left","bottom")}
        >↙</button>

        <button
          className={`${styles.button} ${isActive("center","bottom") ? styles.active : ""}`}
          onClick={() => setAlign("center","bottom")}
        >↓</button>

        <button
          className={`${styles.button} ${isActive("right","bottom") ? styles.active : ""}`}
          onClick={() => setAlign("right","bottom")}
        >↘</button>

      </div>
    </div>
  );
};

export default Align;